'use strict';

const getJson = require('./getJson');
const load = require('./load');
const postForm = require('./postForm');

exports.getJson = getJson;
exports.load = load;
exports.postForm = postForm;
